import { z } from 'zod';

const TLoanStatuses = [
  'Active - Good Standing',
  'Active - Bad Standing',
  'Pending Approval',
  // Replaced with 'Approved - Not signed' might be able to remove this. Levaing for now
  'Approved - Not signed',
  'Approved',
  'Closed - Rejected',
  'Closed - Cancelled',
  'Closed - Obligations Met',
  'Closed - Written Off',
  'Closed - Rescheduled',
  'Closed',
  'Signed'
] as const;
type TLoanStatus = (typeof TLoanStatuses)[number];

type TLoan = {
  originalAccountNumber: string;
  applicationId?: string;
  mambuAccountId: string;
  creationDate: string;
  borrower: string;
  student: string;
  planAmount: number | 'NO_DATA';
  mambuAccountState?: TLoanStatus;
  pol: string;
  polSubCategory: string;
  repaymentFrequency: string;
  fundingStatus: string | null;
  courseEndDate: string | null;
  productType: string;
  fundingDate: string | null;
  fundingStatusText: string | null;
  salesPersonId?: string | null;
  merchantContactEmail?: string | null;
  buttonEligibility?: boolean;
  disbursementDate?: string | null;
  idCheckRequired: boolean;
};

const LoanDetailSchema = z.object({
  email: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  postcode: z.string().nullable(),
  salesPerson: z.string().nullable(),
  firstRepaymentDate: z.string(),
  disbursedAmount: z.number().nullable(),
  pasDowngrade: z.boolean().nullable(),
  anytimeApplicationStatus: z.string().optional().nullable(),
  keyOutcomeReason: z.string().optional().nullable(),
  totalPaid: z.number().optional().nullable(),
  repaymentAmount: z.number().optional().nullable(),
  totalDue: z.number().optional().nullable(),
  daysInArrears: z.number().optional().nullable(),
  contractPdfId: z.string().optional().nullable(),
  nimbleID: z.string().optional().nullable(),
  msfAmount: z.string().optional().nullable(),
  msfGstAmount: z.string().optional().nullable(),
  balanceToEP: z.string().optional().nullable(),
  establishmentFee: z.string().optional().nullable(),
  salesPersonId: z.string().optional().nullable(),
  merchantContactEmail: z.string().optional().nullable()
});

type TLoanDetail = {
  email: string | null;
  phoneNumber: string | null;
  postcode?: string | null;
  salesPerson?: string | null;
  firstRepaymentDate: string;
  nextRepaymentDate: string | null;
  disbursedAmount?: number | null;
  loanTermInMonths?: string | null;
  pasDowngrade?: boolean | null;
  anytimeApplicationStatus?: string | null;
  keyOutcomeReason?: string | null;
  totalPaid?: number;
  planBalance?: number;
  repaymentAmount?: number | null;
  totalDue?: number;
  daysInArrears?: number;
  contractPdfId?: string | null;
  nimbleID?: string | null;
  msfAmount?: string | null;
  msfGstAmount?: string | null;
  balanceToEP?: string | null;
  establishmentFee?: string | null;
  salesPersonId?: string | null;
  merchantContactEmail?: string | null;
};

export {
  LoanDetailSchema,
  type TLoan,
  type TLoanDetail,
  TLoanStatuses,
  type TLoanStatus
};
